// src/seo/StaticPageSeo.tsx
import SeoHead from './SeoHead';
import { getSeoContext } from './seoContext';
import { staticPageMetadata } from './core/staticPages';
import { organizationSchema, webSiteSchema } from './core/structuredData';
import type { PageMetadata } from './types';

export interface StaticPageSeoProps {
  /** Canonical path of this page, e.g. '/about'. */
  path: string;
  /** Emit the platform Organization + WebSite graph (homepage only). */
  includePlatformSchema?: boolean;
}

/**
 * One-line SEO for the fixed public pages (home, about, services, contact and
 * the legal set). Before this, every one of those routes shared a single static
 * `<title>` and description from `public/index.html` and had no canonical at
 * all — ten public URLs presenting as the same page.
 */
function StaticPageSeo({ path, includePlatformSchema }: StaticPageSeoProps) {
  const ctx = getSeoContext();
  const metadata = staticPageMetadata(path, ctx) as PageMetadata | null;
  if (!metadata) return null;

  const jsonLd = includePlatformSchema
    ? [organizationSchema(ctx), webSiteSchema(ctx)]
    : undefined;

  return <SeoHead metadata={metadata} jsonLd={jsonLd} />;
}

export default StaticPageSeo;
